import { render, staticRenderFns } from "./RecipeKeyword.vue?vue&type=template&id=66b9f2fb&scoped=true&"
import script from "./RecipeKeyword.vue?vue&type=script&lang=js&"
export * from "./RecipeKeyword.vue?vue&type=script&lang=js&"
import style0 from "./RecipeKeyword.vue?vue&type=style&index=0&id=66b9f2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b9f2fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b9f2fb')) {
      api.createRecord('66b9f2fb', component.options)
    } else {
      api.reload('66b9f2fb', component.options)
    }
    module.hot.accept("./RecipeKeyword.vue?vue&type=template&id=66b9f2fb&scoped=true&", function () {
      api.rerender('66b9f2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeKeyword.vue"
export default component.exports